export const hasValidLatLng = (obj: any) => obj?.latitude != null && obj?.longitude != null;

export const formattedSecondaryFmsText = (geocoding: any = {}): string => {
  const { street, street_number, zip_code, city } = geocoding;

  let left = "";
  let right = "";

  // LEFT SIDE: street + street_number
  if (street) {
    left = street;
    if (street_number) {
      left += ` ${street_number}`;
    }
  }

  // RIGHT SIDE: zip + city
  if (zip_code) {
    right = zip_code;
  }

  if (city) {
    right = right ? `${right} ${city}` : city;
  }

  // Both exist → join with comma
  if (left && right) {
    return `${left}, ${right}`;
  }

  // Only left or only right → show what exists
  return left || right || "";
};

export const getFormattedRouteAddress = (geocodingRes: any, shouldUseLatLngValidation: boolean) => {
  if (!geocodingRes) return null;

  const hasLatLng = hasValidLatLng(geocodingRes);

  const isValidAddress = shouldUseLatLngValidation ? hasLatLng : !!geocodingRes?.street_number;

  return {
    value: {
      structured_formatting: {
        main_text: geocodingRes?.name || geocodingRes?.street || "",
        secondary_text: formattedSecondaryFmsText(geocodingRes)
      },
      isValidAddress,
      place_id: geocodingRes?.place_id
    }
  };
};
